<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-8 class="text-left fw-500">8. User Conduct</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-8" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Compliance with Laws: The Account Holder must comply with all applicable laws and regulations.</li>
                        <li>Prohibited Conduct: The Platform may suspend or terminate the VA if the Account Holder engages in prohibited activities, including but not limited to, fraudulent behaviour, misuse of the service, or any activity that harms the Platform’s reputation.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-8',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>